import { MDBBtn, MDBCard, MDBCardTitle, MDBIcon } from 'mdbreact';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../../firebase'

function Albums() {

    const [albums, setAlbums] = useState([])

    useEffect(() => {

        try {
            const albumsRef = firestore.collection("albums");
            albumsRef.orderBy("date", "desc").onSnapshot(({docs}) => {
                const albums = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setAlbums(albums);
            })
        } catch (error) {
            
        }

    }, [])

    return (
        <div className="row">
            {albums?.map((album, index) => {
                    return (
                        <div className="col-lg-4 my-3" key={index} >
                            <MDBCard 
                                
                                className='card-image'
                                style={{
                                backgroundImage:
                                    `url('${album.cover_image}')`
                                }}
                            >
                                <div className="text-white text-center d-flex align-items-center rgba-black-strong py-5 px-4">
                                    <div>
                                        <h5 className='green-text'>
                                            <MDBIcon icon='desktop' /> Media
                                        </h5>
                                        <MDBCardTitle tag='h3' className='pt-2'>
                                            <strong>{album.title}</strong>
                                        </MDBCardTitle>
                                        <p>
                                            Foto: {album.photographer}
                                        </p>
                                        <MDBBtn color={'success text-white'}>
                                            <MDBIcon icon='clone left' /> <Link to={`/albums/${album.id}`} className="text-white"> {album.title}</Link>   
                                        </MDBBtn>
                                    </div>
                                </div>
                            </MDBCard>
                        </div>
                    )
            })}
        </div>
    )



}
export default Albums